import { LogoutOutlined } from '@ant-design/icons';
import MiniLogo from '@assets/images/mysg-logo-min.png';
import { useLingui } from '@lingui/react';
import { Divider, Layout, Menu } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const { Sider } = Layout;

type Menu = { key: string; icon: JSX.Element; label: JSX.Element };

function NavBar() {
  const { i18n } = useLingui();
  const [value, setValue] = useState<string>('');

  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    setValue(pathname.substring(1));
  }, [pathname]);

  if (value.length <= 0) {
    return <></>;
  }

  const menuItems = [
    {
      key: 'home',
      icon: <LogoutOutlined />,
      label: (
        <div>
          {i18n._('common.home')}
          <Link to="/home" />
        </div>
      ),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: (
        <div>
          {i18n._('common.logout')}
          <Link to="/logout" />
        </div>
      ),
    },
  ];

  return (
    <Sider collapsible breakpoint="lg" theme="light">
      <SDivLogo>
        <Link to="/bo/home">
          <img src={MiniLogo} alt="mini-logo" onClick={() => setValue('')} />
        </Link>
      </SDivLogo>
      <Divider />
      <Menu
        theme="light"
        mode="inline"
        style={{ borderInlineEnd: 'none' }}
        defaultSelectedKeys={[value]}
        items={menuItems}
      />
    </Sider>
  );
}

export default NavBar;

const SDivLogo = styled.div`
  position: relative;
  height: 8%;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;

  img {
    left: 0;
    top: 0;
    height: 100%;
    object-fit: contain;
    position: absolute;
    width: 100%;
  }
`;
